import { takeLatest, call, put } from "redux-saga/effects";
import { createEntitySaga } from "./apiSagas.js";
import { accountSaga } from "./accountSagas.js";

import { getActionEntityByType } from "../../utils/utils.js";
import { createAction } from "../actions/actionUtils.js";
import { getAccount } from "../reducers/account/accountActions.js";

import { USERS } from "../actions/actionConstants.js";
import { getResourceByAtId } from "../reducers/resources/resourcesActions.js";

export function* userCreateSaga(action) {
  const atId = action.payload.parent;
  const atType = action.payload["@type"];
  const actionEntity = getActionEntityByType(atType);

  // @type is only needed for the saga - remove it before proceeding.
  delete action.payload["@type"];

  yield call(createEntitySaga, actionEntity, { autoComplete: false }, action);
  yield call(accountSaga, undefined, getAccount()); // update permissions data via user endpoint otherwise invite actions won't be available.
  yield put(createAction(actionEntity.POST_COMPLETE));
  yield put(getResourceByAtId(atId, atType, false, false, false));
}

// -- WATCHERS -- //

export function* watchUserSagas() {
  yield takeLatest(USERS.POST, userCreateSaga);
}
